function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#FAFAFA"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0_2289_60937)"
}, React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#EEEEEE"
}), React.createElement("path", {
  d: "M15.8184 20.1758C15.8184 19.0712 16.7138 18.1758 17.8184 18.1758H47.2729C48.3775 18.1758 49.2729 19.0712 49.2729 20.1758V29.8121H15.8184V20.1758Z",
  fill: "#BB866F"
}), React.createElement("path", {
  d: "M21.6364 23.9943C21.6364 22.7893 22.6132 21.8125 23.8182 21.8125H40.9091C42.1141 21.8125 43.0909 22.7893 43.0909 23.9943C43.0909 25.1993 42.1141 26.1761 40.9091 26.1761H23.8182C22.6132 26.1761 21.6364 25.1993 21.6364 23.9943Z",
  fill: "#8E593C"
}), React.createElement("path", {
  d: "M15.6364 28.7227H49.0909L43.4546 45.6318H10L15.6364 28.7227Z",
  fill: "#885540"
}), React.createElement("path", {
  d: "M10 45.6211L43.4546 45.4531V61.9986C43.4546 63.1032 42.5591 63.9986 41.4546 63.9986H12C10.8954 63.9986 10 63.1032 10 61.9986V45.6211Z",
  fill: "#8A553E"
}), React.createElement("path", {
  d: "M15.8184 28.7227H49.2729L53.8184 45.6318H20.3638L15.8184 28.7227Z",
  fill: "#CEA694"
}), React.createElement("path", {
  d: "M20.3671 45.5H53.8126V62.0455C53.8126 63.15 52.9172 64.0455 51.8126 64.0455H22.3671C21.2625 64.0455 20.3671 63.15 20.3671 62.0455V45.5Z",
  fill: "#BC8873"
}), React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  d: "M40.625 51.25C38.9346 51.25 37.6563 53.1857 37.6563 55.5044C37.6563 57.0313 38.1349 58.3324 38.9881 59.1974C39.1258 59.337 39.216 59.5973 39.2188 59.8399L39.3109 62.75L39.3107 63.5839L42.0303 63.596L42.0313 62.7463L42.1542 59.8649L42.1525 59.7347C42.1726 59.4888 42.2027 59.3736 42.3118 59.2535L42.3565 59.2079C43.1877 58.4176 43.5938 57.1281 43.5938 55.5044C43.5938 53.1857 42.3155 51.25 40.625 51.25Z",
  fill: "#8A553E"
}), React.createElement("path", {
  d: "M36.5055 51.6953L36.7751 57.0885C36.8069 57.7233 36.5795 58.3417 36.1486 58.8037L36.0532 58.9003L35.9361 59.0122C35.705 59.2329 35.5569 59.525 35.5141 59.8393L35.503 59.9582L35.3209 63.5692L32.7754 63.5873L32.6245 59.9778C32.6108 59.6492 32.4824 59.3372 32.2639 59.0948L32.1777 59.0073L32.0693 58.9064C31.5969 58.4666 31.3283 57.8531 31.3226 57.2117L31.3255 57.0739L31.5944 51.6953L32.5309 51.7388L32.3713 55.9299C32.3681 56.0038 32.4168 56.0679 32.4851 56.087L32.5207 56.0926L33.4375 56.0928C33.5037 56.0928 33.5611 56.0512 33.5822 56.0082L33.5904 55.9824L33.5932 55.9294L33.5938 51.7188H34.5313V55.9365C34.5313 56.0105 34.5827 56.0725 34.6517 56.0887L34.6875 56.0928H35.589C35.6629 56.0928 35.7249 56.0414 35.7411 55.9724L35.7452 55.9365L35.5691 51.7409L36.5055 51.6953Z",
  fill: "#8A553E"
})), React.createElement("path", {
  d: "M33.1611 32.2339L34.438 28.8123C33.3454 27.0387 32.7139 24.9504 32.7139 22.7143C32.7139 16.2837 37.9268 11.0703 44.3579 11.0703C50.7889 11.0703 56.0019 16.2833 56.0019 22.7143C56.0019 29.1449 50.7889 34.3583 44.3579 34.3583C41.6726 34.3583 39.2018 33.4471 37.232 31.9201L37.236 31.9255L33.1611 32.2339Z",
  fill: "white"
}), React.createElement("path", {
  d: "M49.166 19.1902C49.166 19.0856 49.0726 19 48.9584 19L47.2456 19.0071L44.666 21.8252L42.089 19.0095L40.3736 19.0024C40.2594 19.0024 40.166 19.0856 40.166 19.1926C40.166 19.2378 40.1842 19.2806 40.2153 19.3163L43.5916 23.0024L40.2153 26.6861C40.1842 26.7218 40.166 26.7646 40.166 26.8098C40.166 26.9144 40.2594 27 40.3736 27L42.089 26.9929L44.666 24.1748L47.243 26.9905L48.9558 26.9976C49.07 26.9976 49.1634 26.9144 49.1634 26.8074C49.1634 26.7622 49.1453 26.7194 49.1141 26.6837L45.743 23L49.1193 19.3139C49.1504 19.2806 49.166 19.2354 49.166 19.1902Z",
  fill: "#6B6B6B"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), React.createElement("mask", {
    id: "mask0_2289_60937",
    style: {
      "maskType": "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _ref), _ref2);
};

export default __webpack_public_path__ + "static/media/driverCancelled.b2f2ab25.svg";
export { SvgComponent as ReactComponent };